var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 7.5C1.25 10.9495 4.05053 13.75 7.5 13.75C10.9495 13.75 13.75 10.9495 13.75 7.5C13.75 4.05053 10.9495 1.25 7.5 1.25C4.05053 1.25 1.25 4.05053 1.25 7.5V7.5",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.15 4.8501L9.02251 8.23197C8.89809 8.60526 8.60517 8.89818 8.23188 9.0226L4.85001 10.1501L5.97751 6.76822C6.10192 6.39493 6.39484 6.10201 6.76813 5.9776L10.15 4.8501",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2d1d877b95a8bca3742ab595ec2a9ca2.svg";
export { ForwardRef as ReactComponent };